module.exports = __webpack_public_path__ + "img/banner.8620d87c.png";